if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.purge
) {
  Object.defineProperty(Array.prototype, 'purge', {
    value({
      filterNull = true,
      filterUndefined = true,
      filterFalse = true,
      filterLength = true,
    } = {}) {
      return this.filter(value => {
        return (
          (
            !filterUndefined
            || value !== undefined
          )
          && (
            !filterNull
            || value !== null
          )
          && (
            !filterFalse
            || value !== false
          )
          && (
            !filterLength
            || value.length
          )
        )
      });
    }
  });
}